/**
 * Archived routes from the retired Muggle AI product.
 * Kept for backward compatibility — all page components are lazy-loaded
 * so they never contribute to the initial bundle.
 */
import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import PageLoader from "../components/common/PageLoader";

import { type ITitleRule } from "./types";

const Agreement = lazy(() => import("../pages/main-layout/Agreement"));
const Chat = lazy(() => import("../pages/main-layout/Chat"));
const Discovery = lazy(() => import("../pages/main-layout/Discovery"));
const Tutorial = lazy(() => import("../pages/main-layout/Tutorial"));
const Download = lazy(() => import("../pages/main-layout/creator/Download"));
const Evaluation = lazy(() => import("../pages/main-layout/creator/Evaluation"));
const Schedule = lazy(() => import("../pages/main-layout/creator/Schedule"));
const Workbench = lazy(() => import("../pages/main-layout/creator/Workbench"));

const LazyProtectedRoute = lazy(() => import("../components/auth/ProtectedRoute"));

export const ARCHIVED_TITLE_RULES: ITitleRule[] = [
  { test: (pathname: string) => pathname === "/agreement", title: "Terms & Privacy" },
  { test: (pathname: string) => pathname === "/workbench", title: "Workbench" },
  { test: (pathname: string) => pathname === "/chat", title: "Chat" },
  { test: (pathname: string) => pathname === "/discovery", title: "Discovery" },
  { test: (pathname: string) => pathname === "/schedule", title: "Schedule" },
  { test: (pathname: string) => pathname === "/evaluation", title: "Evaluation" },
  { test: (pathname: string) => pathname === "/download", title: "Download" },
  { test: (pathname: string) => pathname === "/tutorial", title: "Tutorial" },
];

export const archivedRoutes = (
  <>
    <Route path="agreement" element={<Suspense fallback={<PageLoader />}><Agreement /></Suspense>} />
    <Route path="workbench" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Workbench} /></Suspense>} />
    <Route path="chat" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Chat} /></Suspense>} />
    <Route path="discovery" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Discovery} /></Suspense>} />
    <Route path="schedule" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Schedule} /></Suspense>} />
    <Route path="evaluation" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Evaluation} /></Suspense>} />
    <Route path="download" element={<Suspense fallback={<PageLoader />}><LazyProtectedRoute component={Download} /></Suspense>} />
    <Route path="tutorial" element={<Suspense fallback={<PageLoader />}><Tutorial /></Suspense>} />
  </>
);
